export default Object.freeze({
  WEBSITE: "https://inpec-sn.com/",
  CONSUMERKEY: "ck_8732ee6841d526b599c7bcaf83a2c6c66041a10a",
  CONSUMERSECRET: "cs_4785b18447c276dd837528405c3d2690eff22ed9",
});
